export enum ScreenLayout {
  Empty = 'empty',
  Default = 'default',
  DefaultNoSideBar = 'defaultNoSideBar',
  Child = 'child',
}

export type PrivateAndPublicRouteProps = Pick<AppRoute, 'title' | 'screenId'> & {
  Component: React.ComponentType<ControlledType>;
};

export type RewriteUrlPathRoute = {
  resolvedPath: string;
  permission: string;
};
